import React from "react";

const Notification = () => {
  return (
    <div className="w-full overflow-hidden bg-yellow-500">
      <div className="animate-slide whitespace-nowrap text-xs text-black font-semibold p-1 rounded-sm shadow-sm">
        📅 New Admissions Open for 2024!🎓 Apply Now for Expert Guidance! 🎓
        Limited-time Scholarship Opportunities! Apply Now!⏰ Apply Now and
        Secure Your Spot with Our Expert Guidance!"
      </div>
    </div>
  );
};

export default Notification;
